import { AuthId } from "@common/constans";
import { IAirCheckinBoardingPass, IAirCheckinConfirmSeat, IAirCheckinConfirmSeatResponse, IAirCheckinInfo, IAirCheckinReleaseSeat, IAirCheckinRequest, IAirCheckinReserveSeat, IAirCheckinSeatMap, IResponse, ITraveler, MessageType } from "@common/models";
import { IShareInitializeResponse } from "@common/models/ShareInitializeResponse";
import { ISharingRequest } from "@common/models/SharingRequest";
import { ISharingResponse } from "@common/models/SharingResponse";
import Api, { IOptions } from "@service/Api";
import { Action } from "./Proxy";

export function getCheckinInfo<T = IAirCheckinRequest, U = IAirCheckinInfo>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("AirCheckin/Info", {
                ...options,
                raiseError: options?.raiseError ?? true,
                captchaRequierd: options?.captchaRequierd ?? true,
                authenticationId: options?.authenticationId ?? AuthId.OnlineCheckin,
                callBackTrigger: options?.callBackTrigger ?? true,
                ignoreNotificationCodes: [{ code: "chk_00", type: MessageType.Error }]
            });
    }
    return Promise.reject();
}

export function getSeatMap<T = IAirCheckinRequest, U = IAirCheckinSeatMap>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("AirCheckin/SeatMap", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.OnlineCheckin,
                callBackTrigger: options?.callBackTrigger ?? true,
            });
    }
    return Promise.reject();
}

export function reserveSeat<T = IAirCheckinReserveSeat, U = any>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("AirCheckin/Reserve", { ...options, raiseError: options?.raiseError ?? true });
    }
    return Promise.reject();
}

export function releaseSeat<T = IAirCheckinReleaseSeat, U = any>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("AirCheckin/Release", { ...options, raiseError: options?.raiseError ?? true });
    }
    return Promise.reject();
}

export function confirmSeat<T = IAirCheckinConfirmSeat, U = IAirCheckinConfirmSeatResponse>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("AirCheckin/Confirm", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.OnlineCheckin,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function updatePaxInfo<T = IAirCheckinConfirmSeat, U = any>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("AirCheckin/UpdatePax", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.OnlineCheckin,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function offloadSeat<T = IAirCheckinConfirmSeat, U = ITraveler[]>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("AirCheckin/Offload", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.OnlineCheckin,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function getBoardingPass<T = IAirCheckinRequest, U = IAirCheckinBoardingPass>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("AirCheckin/BoardingPass", {
                ...options,
                raiseError: options?.raiseError ?? true,
                captchaRequierd: options?.captchaRequierd ?? true,
                authenticationId: options?.authenticationId ?? AuthId.OnlineCheckin,
                callBackTrigger: options?.callBackTrigger ?? false
            });
    }
    return Promise.reject();
}

export function sharingInitialize<T = ISharingRequest, U = IShareInitializeResponse>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("AirCheckin/Share/Init", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.OnlineCheckin,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function boardingPassSharing<T = ISharingRequest, U = ISharingResponse>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("AirCheckin/Share/Submit", {
                ...options,
                raiseError: options?.raiseError ?? false,
                authenticationId: options?.authenticationId ?? AuthId.OnlineCheckin,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}
